module.exports = __webpack_public_path__ + "img/todo2.b6d3ad43.svg";